import React from "react";
import Journey from "./Journey";

// Position the normal tooltip inside its target while retaining Joyride's spotlight.
const centerInCanvas = {
    name: "centerInCanvas",
    fn: ({rects}) => {
        const margin = 16;
        const clamp = (value, size, viewport) => Math.max(margin, Math.min(value, viewport - size - margin));
        return {
            x: clamp(rects.reference.x + (rects.reference.width - rects.floating.width) / 2, rects.floating.width, window.innerWidth),
            y: clamp(rects.reference.y + (rects.reference.height - rects.floating.height) / 2, rects.floating.height, window.innerHeight),
        };
    },
};

const steps = [
    {
        target: '[data-tour="flow-sidebar"]',
        title: "Choose your flow",
        content: "Start with the Flows list on the left. Select the flow you want to work on, or use its + button to create one. This guide explains the controls; you can try them after finishing the journey.",
        placement: "right",
    },
    {
        target: '[data-tour="flow-node-menu"]',
        title: "Add nodes",
        content: "Next, add a conversation step. For a simple reply, open Output and choose Text. Use Input to collect an answer, or Logic to branch the conversation.",
        placement: "right",
    },
    {
        target: '[data-tour="flow-canvas"]',
        title: "Connect and configure nodes",
        content: "Drag from a node's outgoing connection point to the next node to connect the conversation, starting from Start. Click a node to open its settings and enter its message or rules. Drag the node itself to arrange the flow. Editing is disabled in production mode.",
        placement: "bottom",
        skipScroll: true,
        floatingOptions: {
            strategy: "fixed",
            hideArrow: true,
            flipOptions: false,
            middleware: [centerInCanvas],
        },
    },
    {
        target: '[data-tour="flow-search"]',
        title: "Find a node",
        content: "To find a node later, type its name or message here. Select a result to move to that node and open its settings.",
        placement: "bottom",
    },
    {
        target: '[data-tour="flow-controls"]',
        title: "Navigate the canvas",
        content: "If a node moves out of view, use these controls to zoom, fit the whole flow, or jump back to the start or end node.",
        placement: "left",
    },
    {
        target: '.flow-minimap',
        title: "Use the minimap",
        content: "The minimap gives you an overview of the whole flow and lets you move around quickly.",
        placement: "right",
    },
    {
        target: '[data-tour="flow-save"]',
        title: "Save before testing",
        content: "When your nodes are connected and configured, open this menu and choose Save. Save your changes before testing the conversation. Deploy is a separate action for publishing to the configured production project.",
        placement: "bottom-end",
    },
    {
        target: '[data-tour="flow-test"]',
        title: "Test the saved conversation",
        content: "After saving, open Start and choose Chatbot to test the conversation. Walk through the replies. If you make changes in the Designer, save again before retesting.",
        placement: "bottom-end",
    },
];

export const FlowDesignerJourney = ({run = false, runId = 0, onFinish}) => (
    <Journey key={`${run}-${runId}`} steps={steps} run={run} onFinish={onFinish}/>
);

export default FlowDesignerJourney;
